export const activityBrowsePaths=new Set(['/main/index','/main/bokes','/main/bokesdetail','/main/cloths','/main/clothdetails','/main/retails','/main/retailDetails','/main/fabrics','/main/accessories','/main/decorations','/main/courses','/main/help'])
export function validWebActivity(config:any,now=Date.now()):boolean{
  return config?.enabled===true && (config.mode===undefined || config.mode==='promotion' || config.mode==='coupon' && Boolean(activityCouponTarget(config,Number(config.orgId)))) && typeof config.title==='string' && config.title.length>0 && config.title.length<=300
    && ['spring','shopping','anniversary','midautumn','newyear'].includes(config.base)
    && Number.isFinite(config.startTime) && Number.isFinite(config.endTime) && config.startTime<=now && now<config.endTime
    && typeof config.popupSeconds==='number' && config.popupSeconds>0 && config.popupSeconds<=60
    && Number.isInteger(config.urgentHours) && config.urgentHours>=1 && config.urgentHours<=720
    && Array.isArray(config.lines) && config.lines.length<=6 && config.lines.every((s:any)=>typeof s==='string' && s.length<=100)
}
export function createActivityVisit(){
  const shown=new Set<string>()
  return {claim(key:string){if(shown.has(key))return false;shown.add(key);return true},begin(){shown.clear()}}
}

// 关联只传递当前店铺与券模板，不授予领券或发券能力；旧活动默认为纯宣传。
export function activityCouponContext(query:any,orgId:number):{couponId:number;orgId:number}|null {
  const couponId=Number(query?.activityCouponId),scope=Number(query?.activityOrgId)
  return Number.isSafeInteger(couponId)&&couponId>0&&Number.isSafeInteger(scope)&&scope>=1000&&scope===orgId?{couponId,orgId:scope}:null
}
export function activityCouponTarget(config:any,orgId:number) {
  return config?.mode==='coupon' && Number(config.orgId)===orgId
    ? activityCouponContext({activityCouponId:config.couponId,activityOrgId:orgId},orgId):null
}
